import AXIOS from "./axios";

export class BankAccount {
  static save(bank_account) {
    return AXIOS.post("/gateway_payments/bank_accounts", bank_account);
  }

  static fetch() {
    return AXIOS.get("/gateway_payments/bank_account");
  }

  static delete() {
    return AXIOS.delete("/gateway_payments/bank_account");
  }

  static transfer(bank_transfer) {
    return AXIOS.post("/gateway_payments/bank_transfers", bank_transfer);
  }

  static transfers() {
    return AXIOS.get("/gateway_payments/bank_transfers");
  }

  static financials() {
    return AXIOS.get("/gateway_payments/accounts/financials");
  }
}
